<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h2 class="h2">Agência de Modelos</h2>
        <p>Sistema de Cadastro de Candidatos</p>
      </div>

      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <label for="email">Email:</label>
          <input type="email" id="email" v-model="formData.email" required placeholder="seu@email.com">
        </div>

        <div class="form-group">
          <label for="senha">Senha:</label>
          <input type="password" id="senha" v-model="formData.senha" required placeholder="Sua senha">
        </div>

        <div class="error" v-if="error">{{ error }}</div>

        <button type="submit" class="btn btn-primary login-btn" :disabled="loading">
          {{ loading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { api } from '../services/api'

export default {
  name: 'Login',
  data() {
    return {
      formData: {
        email: '',
        senha: ''
      },
      error: '',
      loading: false
    }
  },
  methods: {
    async login() {
      this.loading = true
      this.error = ''

      try {
        const response = await api.login(this.formData)

        localStorage.setItem('token', response.token)
        localStorage.setItem('usuario', JSON.stringify(response.scouter))

        response.scouter.perfil === "Admin" ? this.$router.push({ name: 'Admin' }) : this.$router.push({ name: 'Dashboard' });

      } catch (error) {
        this.error = error.response?.data?.message || 'Erro ao fazer login'
      } finally {
        this.loading = false
      }
    },
    async verificaToken() {
      if (localStorage.getItem('token') && localStorage.getItem('token') != null) {
        const res = await api.validaToken();
        localStorage.setItem('usuario', JSON.stringify(res.scouter))
        res.scouter.perfil === "Admin" ? this.$router.push({ name: 'Admin' }) : this.$router.push({ name: 'Dashboard' });
      }
    }
  },
  mounted() {
    this.verificaToken();
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
}

.login-card {
  background: white;
  border-radius: 15px;
  padding: 3rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-header h2 {
  color: #333;
  margin-bottom: 0.5rem;
}

.login-header p {
  color: #666;
  font-size: 0.9rem;
}

.login-btn {
  width: 100%;
  margin-top: 1rem;
}

.error {
  color: red;
  margin-top: 1rem;
  text-align: center;
}
</style>